import { ScreenLabel, DisplayText, BodyText, BackNav } from "../../components/mobile/primitives";

export const ANALYSIS_STEPS = [
  { done: true, label: "Lab results · January 2025", detail: "3 biomarkers found" },
  { done: true, label: "Annual checkup · 2023", detail: "Baseline values recorded" },
  { done: true, label: "HbA1c reference ranges", detail: "Age-matched norms loaded" },
  { done: true, label: "LDL cholesterol trend", detail: "4 data points compared" },
  { done: false, label: "Creating your report", detail: null },
];

export function AnalysisRunScreen() {
  return (
    <div style={{ padding: "14px 16px 16px", display: "flex", flexDirection: "column", gap: 0 }}>
      {/* Back */}
      <div style={{ marginBottom: 16 }}>
        <BackNav label="Skills" color="var(--color-kin-lavender)" />
      </div>

      {/* Header */}
      <div style={{ marginBottom: 24, paddingLeft: 4 }}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            background: "rgba(165,144,255,0.15)",
            border: "1px solid rgba(165,144,255,0.3)",
            borderRadius: 20,
            padding: "4px 10px",
            marginBottom: 10,
            boxShadow: "0 2px 8px rgba(165,144,255,0.1)",
          }}
        >
          <div
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: "var(--color-kin-lavender)",
              boxShadow: "0 0 6px var(--color-kin-lavender)",
            }}
          />
          <ScreenLabel>
            <span style={{ color: "var(--color-kin-lavender)", letterSpacing: "0.15em" }}>
              Analysing
            </span>
          </ScreenLabel>
        </div>
        <DisplayText size={28} lineHeight={1.1} color="var(--color-kin-black)">
          Biomarker Timeline
        </DisplayText>
      </div>

      {/* Timeline */}
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          gap: 0,
          paddingLeft: 6,
        }}
      >
        {/* Vertical connecting line */}
        <div
          style={{
            position: "absolute",
            left: 14,
            top: 10,
            bottom: 24,
            width: 2,
            background:
              "linear-gradient(to bottom, rgba(91,122,102,0.4) 0%, rgba(91,122,102,0.4) 75%, rgba(165,144,255,0.35) 75%, rgba(165,144,255,0.35) 100%)",
            borderRadius: 1,
          }}
        />

        {ANALYSIS_STEPS.map((step, i) => {
          const isActive = !step.done;
          const isLast = i === ANALYSIS_STEPS.length - 1;
          return (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 16,
                paddingBottom: isLast ? 0 : 20,
              }}
            >
              {/* Node */}
              <div style={{ marginTop: 2, flexShrink: 0, position: "relative", zIndex: 1 }}>
                {step.done ? (
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    style={{ filter: "drop-shadow(0 2px 4px rgba(91,122,102,0.3))" }}
                  >
                    <circle cx="9" cy="9" r="9" fill="var(--color-kin-green-soft)" />
                    <path
                      d="M5 9 L8 12 L13 6"
                      stroke="var(--color-kin-white)"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </svg>
                ) : (
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      borderRadius: "50%",
                      background: "rgba(165,144,255,0.2)",
                      border: "2px solid var(--color-kin-lavender)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 0 12px rgba(165,144,255,0.4)",
                    }}
                  >
                    <div
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        background: "var(--color-kin-lavender)",
                        boxShadow: "0 0 4px var(--color-kin-lavender)",
                      }}
                    />
                  </div>
                )}
              </div>

              {/* Text */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <BodyText
                  size={isActive ? 12 : 11}
                  color={isActive ? "var(--color-kin-black)" : "var(--color-kin-muted)"}
                  weight={isActive ? 800 : 600}
                >
                  {step.label}
                </BodyText>
                {step.detail && (
                  <BodyText
                    size={9.5}
                    color="var(--color-kin-muted)"
                    weight={500}
                    style={{ marginTop: 2 }}
                  >
                    {step.detail}
                  </BodyText>
                )}
                {isActive && (
                  <BodyText
                    size={9.5}
                    color="var(--color-kin-lavender)"
                    weight={800}
                    style={{ marginTop: 4 }}
                  >
                    In progress…
                  </BodyText>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
